import { Component, ChangeDetectorRef, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { filter, tap } from 'rxjs/operators'
import { environment } from 'src/env/environment'
import { Gift } from 'src/lib/entity/gift'
import { INFINITE_SCROLL_PAGE_SIZE } from 'src/lib/firestore-access'
import { GiftService } from 'src/lib/services/gift-service'
import { PUBLIC_STATUS } from 'src/lib/constants'

@Component({
  selector: 'maglive-admin-gift-index',
  templateUrl: './gift-index.component.html',
  styleUrls: [
    './gift-index.component.scss',
    '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss',
  ],
})
export class AdminGiftIndexComponent implements OnInit {
  isPrivate = false
  searchPublicStatusQuery: PUBLIC_STATUS
  publicGifts$ = this.giftService.publicGifts$
  privateGifts$ = this.giftService.privateGifts$
  editGift: Gift
  /**
   * 無限スクロール対象要素の親クラス名
   * https://www.npmjs.com/package/ngx-infinite-scroll fromRoot
   */
  infiniteScrollParentSelector = '.admin-gift-scroll-wrap'

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    private giftService: GiftService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(filter((x) => x.publicStatus), tap(x => console.log("Eee")))
      .subscribe((x) => {
        console.log(`ngOnInit. x.publicStatus: ${x.publicStatus}`)
        this.isPrivate = x.publicStatus == PUBLIC_STATUS.private
        if (this.isPrivate) {
          this.giftService.resetLastVisible(this.isPrivate)
          this.giftService.loadMorePrivateGifts(
            INFINITE_SCROLL_PAGE_SIZE,
            false
          )
        } else {
          this.giftService.resetLastVisible(this.isPrivate)
          this.giftService.loadMorePublicGifts(INFINITE_SCROLL_PAGE_SIZE, false)
        }
      })
  }

  onCheckBoxChange(isPrivate: boolean): void {
    this.searchPublicStatusQuery = isPrivate
      ? PUBLIC_STATUS.private
      : PUBLIC_STATUS.public
  }

  searchGifts() {
    this.isPrivate = this.searchPublicStatusQuery === PUBLIC_STATUS.private
    if (this.isPrivate) {
      this.router.navigate(['/admin/gifts'], {
        queryParams: { publicStatus: 'PRIVATE' },
      })
      this.giftService.resetLastVisible(this.isPrivate)
      this.giftService.loadMorePrivateGifts(INFINITE_SCROLL_PAGE_SIZE, false)
    } else {
      this.router.navigate([], { relativeTo: this.route })
      this.giftService.resetLastVisible(this.isPrivate)
      this.giftService.loadMorePublicGifts(INFINITE_SCROLL_PAGE_SIZE, false)
    }
  }

  /**
   * スクロールイベントをトリガーする
   */
  onScroll() {
    if (this.giftService.loadingSubject.getValue()) {
      return
    }
    if (this.isPrivate) {
      // this.giftService.setSearchPublicStatusQuery(this.searchPublicStatusQuery)
      this.giftService.loadMorePrivateGifts(INFINITE_SCROLL_PAGE_SIZE, true)
    } else {
      this.giftService.loadMorePublicGifts(INFINITE_SCROLL_PAGE_SIZE, true)
    }
  }

  showGiftUpdateView(gift: Gift): void {
    this.router.navigate(['admin/gifts/' + gift.id + '/edit'])
    this.editGift = gift
  }

  /**
   * @param {string} path ギフトファイルのパスex) /data/gifts/icons/〇〇
   * @returns {string} ギフトファイルのフルパス
   */
  getGiftFilePath = (path: string) => {
    if (environment.name === 'local') {
      return `https://live.stg.mag2.com${path}`
    } else {
      // pathの先頭スラッシュは不要なので除去する
      return environment.baseURL.magliveWeb + path.replace(/\//, '')
    }
  }

  extractFileName = (path: string): string =>
    path.substring(path.lastIndexOf('/') + 1)
}
